import List from '../../containers/Payments/List';
import Entry from '../../containers/Payments';

const paymentRoutes = [
  {
    path: '/payment',
    exact: true,
    auth: true,
    component: List,
  },
  {
    path: '/payment/:type',
    exact: true,
    auth: true,
    component: Entry,
  },
  {
    path: '/payment/:type/:id',
    exact: true,
    auth: true,
    component: Entry,
  },
];

export default paymentRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/payments.jsx